// icons
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
// use navigate hook
import { useNavigate } from "react-router-dom";

export default function SearchForm() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!isAnimating) return;
    const timeout = setTimeout(() => {
      setIsAnimating(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [isAnimating]);

  const handleSearchInput = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.length > 0) {
      navigate(`/search?query=${searchTerm}`);
      setSearchTerm("");
    } else {
      // if input is empty set animation to true
      setIsAnimating(true);
    }
  };
  return (
    <form onSubmit={handleSubmit} className={`${isAnimating ? "animate-shake" : "animate-none"} w-full relative`}>
      <label htmlFor="product-search" className="sr-only">
        Search for a product
      </label>
      <input
        id="product-search"
        value={searchTerm}
        onChange={handleSearchInput}
        className="input pr-[70px]"
        type="text"
        placeholder="Search for a product..."
      />
      <button
        type="submit"
        aria-label="Search"
        className="btn btn-accent absolute top-0 right-0 rounded-tl-none rounded-bl-none">
        <FiSearch className="text-xl" />
      </button>
    </form>
  );
}
